import React from "react";
import { GridProducts } from "../GridProducts";
import CategorySlider from "../CategorySlider";
import GridFilters from "../GridFilters";
import { Box, Button, Grid, Paper, Tooltip, Typography } from "@mui/material";

const DesktopProductGrid = ({
  products,
  pricingData,
  stockInfo,
  customerCategory,
  categoriesAndTypes,
  activeVendor,
  activeFilters,
  pageNumber,
  pageSize,
  total,
  handlePageNumberChange,
  updateQueryParameters,
  vendorOptions,
  makeOptions,
  modelOptions,
  variantOptions,
  yearOptions,
  productCategoriesListToUse,
  productTypesListToUse,
  showAllCategories,
  showAllTypes,
  showMoreCategories,
  showLessCategories,
  showMoreTypes,
  showLessTypes,
  handleFilterChange,
  changePageCategory,
  changePageProductType,
  clearPageProductType,
  handleActiveCategoryChange,
  isMobile,
  loading,
}) => {
  return (
    <Box sx={{ PY: 2, minHeight: "54vh" }}>
      {total === 0 ? (
        <Grid
          container
          spacing={2}
          sx={{ verticalAlign: "middle", alignContent: "center", p: 10 }}
        >
          <Grid item xs={12}>
            <Typography variant="body2" align="center">
              No products matching your criteria.
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="error"
              onClick={() => window.history.back()}
              size="small"
            >
              Try again
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ marginTop: "32px", marginBottom: "32px" }}>
            {categoriesAndTypes && (
              <CategorySlider
                categoriesAndTypes={categoriesAndTypes}
                handleActiveCategoryChange={handleActiveCategoryChange}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            {activeVendor && (
              <Grid container spacing={2} sx={{ marginBottom: "32px" }}>
                <Grid item xs={12} md={4}>
                  <Box
                    sx={{
                      padding: 4,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <Tooltip
                      title={activeVendor.description}
                      arrow
                      placement="top"
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          width: "100%",
                          padding: "8px",
                        }}
                      >
                        <img
                          src={activeVendor.image}
                          alt={activeVendor.name}
                          style={{ maxHeight: "100%", maxWidth: "100%" }}
                        />
                      </Box>
                    </Tooltip>
                  </Box>
                </Grid>
                {activeVendor?.description && (
                  <Grid item xs={12} md={8}>
                    <Box
                      sx={{
                        padding: 4,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        component="p"
                      >
                        {activeVendor.description}
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            )}
          </Grid>
          <Grid item xs={12} md={3} className="mb-5">
            <GridFilters
              activeFilters={activeFilters}
              showAllCategories={showAllCategories}
              showAllTypes={showAllTypes}
              changePageCategory={changePageCategory}
              changePageProductType={changePageProductType}
              clearPageProductType={clearPageProductType}
              makeOptions={makeOptions}
              handleFilterChange={handleFilterChange}
              productCategoriesListToUse={productCategoriesListToUse}
              variantOptions={variantOptions}
              yearOptions={yearOptions}
              showMoreCategories={showMoreCategories}
              showLessCategories={showLessCategories}
              modelOptions={modelOptions}
              vendorOptions={vendorOptions}
              productTypesListToUse={productTypesListToUse}
              showMoreTypes={showMoreTypes}
              showLessTypes={showLessTypes}
            />
          </Grid>
          <Grid item xs={12} md={9}>
            <GridProducts
              products={products}
              pricingData={pricingData}
              stockInfo={stockInfo}
              customerCategory={customerCategory}
              pageNumber={pageNumber}
              handlePageNumberChange={handlePageNumberChange}
              totalResults={total}
              pageSize={pageSize}
              itemsPerRow={isMobile ? 2 : 3}
              loading={loading}
              categoriesAndTypes={categoriesAndTypes}
            />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default DesktopProductGrid;
